<template>
  <div class="login">
    <div class="return-wrap">
      <div class="return" @click="submit2">{{$t('pages_account_login_128')}}</div>
    </div>
    <div class="logo">
      <img :src="oem.icon || defaultIcon" :alt="$config.title"/>
    </div>
    <div class="theme">
      <p v-if="oem.product_name">{{$t('pages_account_login_129', [ oem.product_name ])}}</p>
      <p v-else>{{$t('pages_account_login_130', [ $config.title  ])}}</p>
    </div>
    <div class="float-block">
      <form id="session-form">
        <div class="form-input-wrap">
          <div class="switch-btn-box" v-if="false">
            <div
              :class="[
                'switch-btn',
                {
                  active: isSms === false,
                },
              ]"
              @click="changeLoginType(false)"
            >{{$t('pages_account_login_131')}}</div>
            <div
              :class="[
                'switch-btn',
                {
                  active: isSms === true,
                },
              ]"
              @click="changeLoginType(true)"
            >{{$t('pages_account_login_132')}}</div>
          </div>
          <template v-if="isSms">
            <div class="input-group smsMobile" style="margin-top: 1.5vw">
              <el-select class="countryMobileCode" v-model="countryMobileCode" filterable :placeholder="$t('pages_account_login_133')">
                <el-option
                  v-for="item in countryMobileCodes"
                  :key="item.value"
                  :label="`${item.label} +${item.value}`"
                  :value="item.value">
                </el-option>
              </el-select>
              <input type="tel" class="form-control phone-input chengbao-keyboard" :placeholder="$t('pages_account_login_134')" v-model="phone" @input="changeMobile" />
              <span class="input-group-btn" v-if="!isSetPwd">
                <button class="btn btn-default" type="button" @click="sendCode">
                  <span v-if="isSendCode" style="color: #d6d6d6">{{ countdown }}s</span>
                  <span v-if="!isSendCode">{{$t('pages_account_login_135')}}</span>
                </button>
              </span>
            </div>
            <div class="input-group">
              <input type="text" class="form-control captcha-input chengbao-keyboard" :placeholder="$t('pages_account_login_136')" autocomplete="off" v-model="code" />
            </div>
          </template>
          <template v-else>
            <div class="input-group" style="margin-top: 1.5vw">
              <input type="tel" class="form-control phone-input chengbao-keyboard" :placeholder="$t('pages_account_login_137')" v-model="phone" @input="changeMobile" />
            </div>
            <div class="input-group">
              <input type="password" class="form-control captcha-input chengbao-keyboard" :placeholder="$t('components_loginform_2')" autocomplete="off" v-model="code" />
            </div>
          </template>
          <div class="form-submit" @click="submit">{{$t('components_loginform_3')}}</div>
          <div class="reset-row">
            <div class="reset-wrap">
              <el-checkbox text-color="#d43c33" fill="#d43c33" v-model="rememberMobile">{{$t('pages_account_login_138')}}</el-checkbox>
              <div>
                <a v-if="isSetPwd" href="javascript:;" class="reset-btn" @click="toSmsLogin" style="margin-right: 1.8vw">{{$t('pages_account_login_139')}}</a>
                <a v-else href="javascript:;" class="reset-btn" @click="toPwdLogin" style="margin-right: 1.8vw">{{$t('pages_account_login_140')}}</a>
                <router-link to="/reset" class="reset-btn">{{ isSetPwd ? $t('pages_account_login_141') : $t('pages_account_login_142') }}</router-link>
              </div>
            </div>
            <div class="tip" v-if="false">
              <input type="checkbox" name="agree_protocol" id="agree_protocol" v-model="isAgreeProtocol" checked="checked" />{{$t('pages_account_login_143')}}<a href="https://www.chengbao68.com/merchant/pages/fuwuxieyi">{{$t('pages_account_login_144', [$config.title])}}</a>
            </div>
          </div>
        </div>
      </form>
      <!-- <p class="operate removed">
           <span>{{若您没有${$config.title}商家账号}}</span>
           {{联系${$config.title}客服开通}}
      </p> -->
    </div>
    </div>
</template>

<script>
import i18n from '../../locales/index'

import axios from 'axios'
import { mapGetters, mapActions, mapState } from 'vuex'
import { backToAndroidCash } from '@/libs/android_jsbridge'
import { openUrlOnBrowser } from '@/libs/window_jsbridge'
import { countryMobileCodes } from '@/libs/value-list'

export default {
  name: 'login',
  components: {},
  data () {
    return {
      defaultIcon: this.$config.logo,
      phone: '',
      code: '',
      isAgreeProtocol: true,
      isSendCode: false,
      countdown: 60,
      timer: '',
      // isDisabled: true,
      isSms: true,
      category: 'password',
      isSetPwd: false,
      rememberMobile: true,
      countryMobileCode: '86',
      countryMobileCodes
    };
  },
  computed: {
    ...mapGetters('editor', ['me']),
    ...mapState('oem', ['oem'])
  },
  watch: {
    // code (val) {
    //   this.btnIsDisabled(val);
    // },
    // phone (val) {
    //   this.btnIsDisabled(val);
    // },
  },
  created () {
    this.checkUser();
    localStorage.setItem('SHOPID', '');
  },
  methods: {
    ...mapActions('editor', ['login']),

    // 检查用户登录信息
    async checkUser () {
      const mobile = localStorage.getItem('reMobile');
      const countryMobileCode = localStorage.getItem('reCountryMobileCode');
      if (mobile) {
        this.phone = mobile;
        axios.get('/sessions/check_user', { params: { mobile } }).then(({ data }) => {
          this.isSms = !data;
          this.category = this.isSms ? 'sms' : 'password';
          this.isSetPwd = data;
        });
      }
      if (countryMobileCode) {
        this.countryMobileCode = countryMobileCode;
      }
    },
    //  去短信登录
    toSmsLogin () {
      this.isSms = true;
      this.isSetPwd = false;
    },
    //  去密码登录
    toPwdLogin () {
      this.isSms = false;
      this.isSetPwd = true;
    },
    // 改变手机号时,检查登录人信息
    changeMobile (e) {
      const ph = e.target.value;
      if (ph.length === 11) {
        axios.get('/sessions/check_user', { params: { mobile: ph } }).then(({ data }) => {
          this.isSms = !data;
          this.category = this.isSms ? 'sms' : 'password';
          this.isSetPwd = data;
        });
      }
    },
    changeLoginType (bl) {
      this.isSms = bl;
      this.category = bl ? 'sms' : 'password';
      this.code = '';
      this.phone = '';
    },
    async sendCode () {
      this.category = this.isSms ? 'sms' : 'password';
      const inlandMobileReg = /^(1)\d{10}$/
      if (this.timer) return;
      if (this.phone === '') {
        this.$message({
          duration: 1000,
          message: i18n.t('pages_account_login_134'),
          type: 'error',
        });
        return -1;
      }
      // if (!inlandMobileReg.test(this.phone)) {
      //   this.$message({
      //     duration: 1000,
      //     message: '请输入正确的手机号',
      //     type: 'error',
      //   });
      //   return -1;
      // }
      const countryMobile = this.category === 'sms' ? (inlandMobileReg.test(this.phone) ? '' : this.countryMobileCode) + this.phone : this.phone
      await axios.post('/sessions/sms', {
        mobile: countryMobile
      }).then(() => {
        this.$message({
          duration: 2000,
          message: i18n.t('pages_account_login_145'),
          type: 'success',
        });
        this.isSendCode = true;
        this.countdownFun();
      }).catch(() => {
        this.$message({
          duration: 2000,
          message: i18n.t('pages_account_login_146'),
          type: 'error',
        });
      });
    },
    countdownFun () {
      this.timer = setInterval(() => {
        this.countdown--;
        if (this.countdown === 0) {
          clearInterval(this.timer);
          this.countdown = 60;
          this.isSendCode = false;
        }
      }, 1000);
    },
    // btnIsDisabled (val) {
    //   if (val && val.length === 4 && /^(1)\d{10}$/.test(this.phone)) {
    //     this.isDisabled = false;
    //   } else {
    //     this.isDisabled = true;
    //   }
    // },
    submit () {
      this.category = this.isSms ? 'sms' : 'password';
      const inlandMobileReg = /^(1)\d{10}$/
      if (!this.phone) {
        this.$message({
          duration: 1000,
          message: i18n.t('components_loginform_4'),
          type: 'error',
        });
        return;
      }
      // if (!inlandMobileReg.test(this.phone)) {
      //   this.$message({
      //     duration: 1000,
      //     message: '请输入正确的手机号',
      //     type: 'error',
      //   });
      //   return;
      // }
      if (!this.code) {
        this.$message({
          duration: 1000,
          message: this.category === 'password' ? '密码不能为空' : i18n.t('pages_account_login_147'),
          type: 'error',
        });
        return;
      }
      if (this.rememberMobile) {
        localStorage.setItem('reCountryMobileCode', this.countryMobileCode);
        localStorage.setItem('reMobile', this.phone);
      } else {
        localStorage.setItem('reMobile', '');
      }
      const countryMobile = this.category === 'sms' ? (inlandMobileReg.test(this.phone) ? '' : this.countryMobileCode) + this.phone : this.phone
      this.login({ mobile: countryMobile, code: this.code, category: this.category })
    },
    submit2 () {
      backToAndroidCash()
      openUrlOnBrowser()
    }
  }
};
</script>
<style lang="scss">
.reset-row .reset-wrap {
  .el-checkbox__input.is-checked + .el-checkbox__label {
    color: #d43c33;
    font-size: 16px;
  }
  .el-checkbox__input.is-checked .el-checkbox__inner,
  .el-checkbox__input.is-indeterminate .el-checkbox__inner {
    background-color: #d43c33;
    border-color: #d43c33;
    font-size: 16px;
  }
}
</style>
<style lang="scss">
@import './login.scss';
.login-go-home {
  position: fixed;
  top: 0;
  left: 0;
}
.switch-base-url {
  position: fixed;
  top: 0;
  right: 0;
  width: 50px;
  height: 50px;
  cursor: progress;
}
</style>
